export default __webpack_public_path__ + "media/img/powered_by_stripe-7f1e4e15e8f5e21e8401d17c6aab4414.svg";